const adPlatMap = {
	400: '头条',
	6: '快手',
	1: '广点通'
}
const adReportOrderStatusMap = {
	1: '下单',
	2: '付款'
}
const adReportEventMap = {
	1: '头条-app内下单|in_app_order',
	// 2: '头条-app内付费|in_app_pay',
	// 3: '头条-付费|active_pay',
	4: '头条-商品购买|shopping',
	// 5: '头条-支付成功|successful_pay',
	60: '快手-付费|3',
	61: '快手-提交订单|14',
	70: '广点通-下单|COMPLETE_ORDER',
	// 71: '广点通-付费|PURCHASE',
}
const phAppIncMap = {
	7: '系统默认-头条'
}

export {
	adPlatMap,
	adReportOrderStatusMap,
	adReportEventMap,
	phAppIncMap
}


// WEBPACK FOOTER //
// ./src/utils/map.js